import { Navigate } from "react-router-dom";
import { useSiteSettings } from "@/context/SiteSettingsContext";

// Redirects to home if a feature has been disabled by the admin.
export const FeatureRoute = ({ feature, children }) => {
  const { ready, isEnabled } = useSiteSettings();
  if (ready && !isEnabled(feature)) return <Navigate to="/" replace />;
  return children;
};
